<template>
    <div>
        <div class="t-page" v-show="isSuccess == false">
            <div class="banner">
                <img src="https://resources.holowits.com.sg/banner/register---JP.jpg" alt="">
                <!-- <p style="color: #000000; font-size: 11px;">Registration will close when the number of registrants reaches the maximum. Please register as soon as possible.</p>
                <p style="color: #000000; font-size: 11px;">One registeration for one person. Thank you for your cooperation.</p> -->
            </div>
            <div class="title first">
                お問い合わせ情報 How can we reach you?
            </div>
            <div class="t-input" :class="{'error': rules.fullName}">
                <input class="el-input__inner" v-model="form.fullName"/>
                <div :class="['t-label', form.fullName != ''? 'focus': null]">氏名 Full Name</div>
            </div>
            <div class="t-input">
                <!-- <el-select v-model="form.jobTitle" filterable placeholder="役職" style="width: 100%;" @focus="activity1 = true" @blur="activity1 = false">
                    <el-option label="CEO（最高経営責任者）" value="CEO"></el-option>
                    <el-option label="CIO/ITマネージャー" value="CIO/IT Manager"></el-option>
                    <el-option label="マーケティングディレクター/マネージャー" value="Marketing Director/Manager"></el-option>
                    <el-option label="営業ディレクター/マネージャー" value="Sales Director/Manager"></el-option>
                    <el-option label="技術ディレクター/マネージャー" value="Technical Director/Manager"></el-option>
                    <el-option label="エンジニアリング/技術スタッフ" value="Engineering/Technical Staff"></el-option>
                    <el-option label="その他" value="Other"></el-option>
                </el-select>
                <div :class="['t-label', 'optional', form.jobTitle != ''? 'focus': null, activity1 ? 'focus2': null]">役職</div> -->
                <input class="el-input__inner" v-model="form.jobTitle"/>
                <div :class="['t-label', 'optional', form.jobTitle != ''? 'focus': null]">役職 Job Title</div>
            </div>
            <div class="t-input">
                <input class="el-input__inner" v-model="form.email"/>
                <div :class="['t-label', 'optional', form.email != ''? 'focus': null]">メールアドレス Email</div>
            </div>
            <div class="t-input">
                <input class="el-input__inner" v-model="form.telephone"/>
                <div :class="['t-label', 'optional', form.telephone != ''? 'focus': null]">電話番号 Telephone</div>
            </div>
            <div class="t-input">
                <input class="el-input__inner" v-model="form.whatsappId"/>
                <div :class="['t-label', 'optional', form.whatsappId != ''? 'focus': null]">Whatsapp ID</div>
            </div>
            <div class="title first">
                会社情報 Company Details
            </div>
            <div class="t-input" :class="{'error': rules.companyName}">
                <input class="el-input__inner" v-model="form.companyName"/>
                <div :class="['t-label', form.companyName != ''? 'focus': null]">会社名 Company Name</div>
            </div>
            <div class="t-input">
                <input class="el-input__inner" v-model="form.businessType"/>
                <div :class="['t-label', 'optional', form.businessType != ''? 'focus': null]">業種 Business Type</div>
            </div>
            <div class="t-input">
                <input class="el-input__inner" v-model="form.country"/>
                <div :class="['t-label', 'optional', form.country != ''? 'focus': null]">国 Country</div>
            </div>
            <!-- <div class="title first">
                Sign up for Partner Roundtable
            </div>
            <div class="t-input" :class="{'error': rules.roundtable}">
                <el-select id="selector1" v-model="form.roundtable" filterable placeholder="Partner Roundtable (Hatta B)" style="width: 100%;" @focus="activity3 = true" @blur="activity3 = false">
                    <el-option label="Not Participate" value="Not Participate"></el-option>
                    <el-option label="Oct 15th 15:30-17:00" value="Oct 15th 15:30-17:00"></el-option>
                </el-select>
                <div :class="['t-label', form.roundtable != ''? 'focus': null, activity3 ? 'focus2': null]">Partner Roundtable (Hatta B)</div>
            </div> -->
            <div class="title first">
                <div>HOLOWITSとの今後の協力について、ご意見やご要望があればお聞かせください。</div>
                <div>Do you have any feedback or comments on future cooperation with HOLOWITS?</div>
            </div>
            <div class="t-input">
                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="form.difficulty"></el-input>
            </div>
            <div class="t-input" :class="{'error': rules.authorization}">
                <input type="checkbox" v-model="form.authorization" style="margin-right: 10px;"/><i style="color: red; padding-right: 5px;">*</i>
                <span>今後の協力促進とより良いサービス提供のため、HOLOWITSおよびその販売代理店はお客様の情報を保持する場合があります。<br/>To promote future cooperation and provide you with better services, HOLOWITS and its distributors may retain your information.</span>
                
                <!-- <div v-show="!form.authorization" class="error-info">This field is required.</div> -->
            </div>
            
            <div class="t-input" style="display: flex; justify-content: center;">
                <el-button round style="background-color: #c7000b; color: #ffffff; width: 160px;" :loading="isLoading" @click="add">送信 Submit</el-button>
            </div>
        </div>
        <div v-show="isSuccess === true" style="text-align: center;">
            <img src="https://resources.holowits.com.sg/banner/invitation-jp.jpg" alt="">
        </div>
    </div>
</template>
  
<script>
  import countrys from '@/utils/country.json';
  import {save} from '@/api/otherFormApi';
  export default {
    name: 'GitexIndex',
  data() {
      return {
          isSuccess: false,
          language: 'en',
          activity1: false,
          activity2: false,
          activity3: false,
          activity4: false,
          activity5: false,
          form: {
            fullName: '',
            jobTitle: '',
            email: '',
            telephone: '',
            whatsappId: '',
            companyName: '',
            businessType: '',
            country: '',
            // roundtable: '',
            difficulty: '',
            authorization: false
          },
          rules: {
            fullName: false,
            companyName: false,
            // roundtable: false,
            authorization: false
          },
          countryArr: [],
          isLoading: false,
          hasError: false
      }
  },
  created() {
      this.countryArr = countrys.country.map(item => {
          return {label: item, value: item}
      })
  },
  watch: {
    form: {
        handler(n, v) {
            let checkList = Object.keys(n)
            for (let key of checkList) {
                this.check(key, n[key])
            }
        },
        deep: true
    }
  },
  methods: {
    check(key, value) {
        if (key in this.rules) {
            return this.rules[key] = value ? false : true;
        }
    },
     async add() {
        this.form['source'] = 'securityshow-japan'
        let checkList = Object.keys(this.rules)
        let hasError = false
        for (let key of checkList) {
            if (this.check(key, this.form[key])) {
                hasError = true
            }
        }
        if (hasError) {
            return false;
        }

        if (this.isLoading) {
            return false;
        }

        try {
            this.isLoading = true
            const {data: {data, isSuccess}} = await save({
                content: JSON.stringify(this.form),
                pageSource: 'securityshow-japan'
            })
            if (isSuccess) {
                this.isLoading = false
                this.isSuccess = true
            } else {
                this.isLoading = false
            }
        } catch(e) {
            this.isLoading = false
        }
    }
  }
  }
</script>
  
<style lang="scss" scoped>
  .t-page {
    padding-bottom: 30px;
  }
  .banner {
      width: 100%;
      img {
          width: 100%;
      }
  }
  .error-info {
      color: red;
      font-size: 12px;
  }
  .company-icon {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
  
      .left {
          width: 163px;
          height: 80px;
      }
      .line {
          height: 40px;
          width: 2px;
          background-color: #000000;
      }
      .right {
          width: 105px;
          height: 105px;
      }
  }
  .first {
      margin-top: 20px;
  }
  
  .title {
      font-size: 18px;;
      font-weight: 600;
      margin-bottom: 20px;
  }
  .require {
    &::after {
        content: '*';
        padding-left: 2px;
        color: #c7000b;
    }
  }
  .t-input {
      margin-bottom: 20px;
      position: relative;
  
      .t-label {
          position: absolute;
          font-size: 14px;
          top: 10px;
          left: 16px;
          background-color: #ffffff;
          color: #C0C4CC;
          transition: all 0.4s;
  
          &::after {
              content: '*';
              padding-left: 2px;
              color: #c7000b;
          }
      }
      .optional {
          &::after {
              content: '';
          }
      }
      .focus {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
      .focus2 {
          padding: 0 5px;
          top: -12px;
          left: 12px;
          font-size: 12px;
      }
      .el-input__inner:focus+.t-label {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
  }
  .error {
   ::v-deep input {
        border-color: rgb(199, 0, 11) !important;
    }
    span {
        color: #c7000b;
    }
  }
  @media only screen and (min-width: 992px) {
      .t-page {
          max-width: 838px;
          margin: 20px auto;
      }
  }
  @media only screen and (max-width: 991px) {
      .t-page {
          width: 100%;
          margin: 20px auto;
          padding: 15px;
      }
  }
</style>